var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7359 7.77056C13.5667 7.91747 13.3373 8 13.098 8C12.8588 8 12.6294 7.91747 12.4602 7.77056L7.99455 3.89154L3.52889 7.77056C3.35874 7.91331 3.13086 7.99229 2.89431 7.99051C2.65777 7.98872 2.4315 7.90631 2.26423 7.76101C2.09697 7.61572 2.00209 7.41917 2.00004 7.21371C1.99798 7.00824 2.08891 6.81029 2.25325 6.66249L7.35673 2.22944C7.52591 2.08253 7.75533 2 7.99455 2C8.23377 2 8.4632 2.08253 8.63238 2.22944L13.7359 6.66249C13.905 6.80945 14 7.00873 14 7.21653C14 7.42432 13.905 7.62361 13.7359 7.77056Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7359 13.7706C13.5667 13.9175 13.3373 14 13.098 14C12.8588 14 12.6294 13.9175 12.4602 13.7706L7.99455 9.89154L3.52889 13.7706C3.35874 13.9133 3.13086 13.9923 2.89431 13.9905C2.65777 13.9887 2.4315 13.9063 2.26423 13.761C2.09697 13.6157 2.00209 13.4192 2.00003 13.2137C1.99798 13.0082 2.08891 12.8103 2.25324 12.6625L7.35673 8.22944C7.52591 8.08253 7.75533 8 7.99455 8C8.23377 8 8.4632 8.08253 8.63238 8.22944L13.7359 12.6625C13.905 12.8094 14 13.0087 14 13.2165C14 13.4243 13.905 13.6236 13.7359 13.7706Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.5fa0d80e29b7608c1a34b2a82e582202.svg";
export { ForwardRef as ReactComponent };